module.exports = __webpack_public_path__ + "img/15.9403c80d.png";